import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Checkout/CheckoutDetailsButton/checkoutDetailsButton.container"
    ).then((module) => ({ default: module.CheckoutDetailsButton }))
);
